export default __webpack_public_path__ + "static/media/cadeaux-9.a5205fc8.jpeg";